import { IBasemap, IBasemapGroup, IMapContainer } from "../../map/types"
import { Checkbox } from "../checkbox"
import { useForceUpdate } from "../hooks"


interface Props {
    map: IMapContainer
    bmg: IBasemapGroup
}

export function BasemapListItem({ map, bmg }: Props) {

    const refresh = useForceUpdate()

    let currentIndex = bmg.basemaps.indexOf(bmg.basemap)

    const setVisibility = (visible: boolean) => {
        bmg.visible = visible
        refresh()
    }
    const selectBasemap = (index: number) => {
        bmg.basemap = bmg.basemaps[index]
        currentIndex = index
        refresh()
    }

    const viewBasemap = (basemap: IBasemap) => {
        map.viewExtent(basemap.getExtent())
    }

    return <Checkbox
        cssClass="layer basemap"
        checked={bmg.visible}
        setChecked={setVisibility}>

        <>
            <span>
                <select className="form-control input-sm" value={currentIndex} onChange={e => selectBasemap(Number(e.target.value))}
                    disabled={!bmg.visible}>
                    {bmg.basemaps.map((bm, index) => <option key={index} value={index}>{bm.name}</option>)}
                </select>
            </span>
            {
                bmg.custom && bmg.visible &&
                <button className="btn btn-icon-toggle btn-link" onClick={() => viewBasemap(bmg.basemap)}>
                    <i className="icon icon-search"></i>
                </button>
            }
        </>

    </Checkbox>

}
